/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytoolfilter3Inputs */

const en_medialibrarytoolfilter3 = /** @type {(inputs: Medialibrarytoolfilter3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const de_medialibrarytoolfilter3 = /** @type {(inputs: Medialibrarytoolfilter3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

/**
* | output |
* | --- |
* | "Filter" |
*
* @param {Medialibrarytoolfilter3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytoolfilter3 = /** @type {((inputs?: Medialibrarytoolfilter3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytoolfilter3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytoolfilter3(inputs)
	return de_medialibrarytoolfilter3(inputs)
});
export { medialibrarytoolfilter3 as "mediaLibraryToolFilter" }